import { render, staticRenderFns } from "./SmartItemParts.vue?vue&type=template&id=b3871c7a&"
import script from "./SmartItemParts.vue?vue&type=script&lang=js&"
export * from "./SmartItemParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports